import { createApp } from 'vue';
import axios from 'axios';

const articlesList = async () => {
  const list = document.querySelector('.articles-list');
  if (!list) {
    return;
  }

  const app = createApp({
    delimiters: ['${', '}'],
    data() {
      return {
        showSpinner: 1,
        total: 0,
        categories: [],
        selectedCategory: 'All News',
        articles: [],
        page: 1,
        numberOfPages: 0,
        perPage: 9,
        pages: []
      };
    },
    methods: {
      getCategories() {
        return axios.get('/api/categories.json').then(response => {
          this.categories = response.data.data;
        });
      },
      getArticles() {
        return axios.get('/api/news.json').then(response => {
          this.articles = response.data.data;
        });
      },
      resetPage() {
        this.page = 1;
      },
      setNumberOfPages(length) {
        this.numberOfPages = Math.ceil(length / this.perPage);
      },
      setPages() {
        this.showSpinner = 0;
        this.setNumberOfPages(this.articles.length);
        for (let index = 1; index <= this.numberOfPages; index += 1) {
          this.pages.push(index);
        }
      },
      getQueryStringCategory() {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get('category');
      },
      selectCategory() {
        const slug = this.getQueryStringCategory();
        const catObject = this.categories.find((c) => c.slug == slug);

        if(catObject) {
          this.selectedCategory = catObject.title;
        }
      },
      paginate(articles) {
        this.total = articles.length;
        this.setNumberOfPages(this.total);
        const { page } = this;
        const { perPage } = this;
        const from = 0;
        const to = page * perPage;
        return articles.slice(from, to);
      }
    },
    computed: {
      displayedArticles() {
        const category = this.selectedCategory;
        if (category === 'All News') {
          return this.paginate(this.articles);
        }
        return this.paginate(
            this.articles.filter(article => article.category === category)
        );
      }
    },
    created() {
      this.getCategories()
          .then(() => this.selectCategory())
          .then(() => this.getArticles());
    },
    watch: {
      articles() {
        this.setPages();
      }
    }
  });

  app.mount(list);
};

export default articlesList;
